module.exports = __webpack_public_path__ + "media/images/lb/190-2ff89c02f56251f62920b6ae098132e2.svg";